import { CASH as CASH_PAYMENT_METHOD } from '@models/PaymentMethods.model';

export default function sortPaymentMethodsByName(x, y) {
  // Ask first for CASH uiType, so we give preference to that.
  if (x.uiType === CASH_PAYMENT_METHOD) return -1;
  if (y.uiType === CASH_PAYMENT_METHOD) return 1;
  if (x.descriptionES < y.descriptionES) return -1;
  if (x.descriptionES > y.descriptionES) return 1;
  return 0;
}
